<template>
    <div>
        <section class="page-title">
            <v-img 
                v-if="this.$vuetify.breakpoint.lg"
                height="330px"        
                :src="require('@/Content/images/banner2.png')"
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"  
            >
                <div class="center">
                    <p class="label-planos">{{informacaoOperadora("nome")}}</p>
                    <h1 class="the-title">Amar também é <span>prevenção</span></h1>
                    <p style="color:#666">Planos veterinários simples e acessíveis</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
                </div>
            </v-img>
            <v-img 
                v-else
                height="300"        
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"  
                position="center top"        
            >
                <div class="center">
                    <p class="label-planos" >Pessoa Física</p>
                    <h1 class="the-title"><span>Soluções</span> para o seu Pet</h1>
                    <p style="color:#7593b4">Garanta o bem estar do seu bichinho!</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
                </div>
            </v-img>
        </section>
        <section class="page-content center">
            <p class="title-label">Sobre nós</p>
            <p>Ter um plano de saúde veterinário não é um luxo e sim uma necessidade. Foi com essa visão que a {{informacaoOperadora("nome")}} surgiu, com o desejo de trazer qualidade nos serviços prestados de uma forma acessível para todos os públicos, surpreendendo assim até os clientes mais exigentes. Além disso, a {{informacaoOperadora("nome")}} é o primeiro plano veterinário do Nordeste que possuí especialidades, pois tem como meta alcançar e avançar junto a medicina humana. Prezamos para que o seu pet tenha o melhor atendimento, e para que você possua uma experiência exclusiva e satisfatória ao utilizar o nosso plano, por isso buscamos sempre os melhores profissionais para acrescer a nossa equipe. Seja bem vindo (a)!</p>
            <p class="title-label">Por que contratar a {{informacaoOperadora("nome")}}?</p>
            <p><strong>- Somos eficientes:</strong> A {{informacaoOperadora("nome")}} trabalha arduamente para ser eficiente ao máximo no atendimento ao seu pet na hora que precisar.</p>
            <p><strong>- Variedade de serviços:</strong> Oferecemos diversos serviços no plano de saúde do seu pet, de atendimento 24 horas e emergencial a internamento com medicações.</p>
            <p><strong>- Segurança para o seu pet:</strong> De cirurgias a fisioterapia a {{informacaoOperadora("nome")}} disponibiliza segurança para que seu pet seja atendido de forma personalizada.</p>
            <!-- IMAGEM COM DESCONTOS -->
            <p class="title-label">Momento ONG</p>
            <p>O aumento de animais abandonados e torturados tem crescido cada vez mais por conta da falta de conscientização das pessoas para com os animais. Esse cenário foi uma das preocupações da {{informacaoOperadora("nome")}}, por essa razão abrimos o plano pensando na causa social e em como poderíamos ajudar de forma direta. Foi dando a real importância que essa causa merece, que firmamos parceria com a ONG e um percentual do faturamento total da {{informacaoOperadora("nome")}} é doado para a mesma. Quando você adquire o plano de saúde veterinário {{informacaoOperadora("nome")}}, além de desfrutar de todos os nossos benefícios você também ajuda essa causa! Obrigado (a)!</p>
            <div class="contrataragora"> 
                <v-fade-transition mode="out-in">    
                    <div class="exibelocalizacao" v-if="exibeLocalizacao"> 
                        <div class="planos-wrapper">
                            <p class="planos-title">Local de utilização</p>
                            <v-layout align-center>
                                <v-flex xs12 sm12>
                                    <v-card
                                        flat
                                        max-height="400px"
                                        max-width="600px"
                                        class="mx-auto localizacao"
                                        style="border: 1px solid; border-color: #7e2985;border-radius: 10px;"
                                    >
                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout align-center justify-center row wrap>
                                                    <v-flex xs12 sm12 lg10>
                                                        <v-select
                                                            id="comboOrgao"
                                                            v-model="abrangenciaAgrupamento"
                                                            item-value="abrangenciaId"
                                                            item-text="agrupamento"
                                                            :items="agrupamentosUF"
                                                            label="Local de Utilização"
                                                        ></v-select>
                                                    </v-flex>
                                                    <v-layout align-center justify-center row wrap>
                                                        <v-flex xs12 sm6 md6 lg6 >
                                                            <v-btn
                                                                style="border-radius: 6px;"
                                                                large
                                                                dark
                                                                @click="controlaExibicaoPlanos()"
                                                                color="#7e2985"
                                                            >Consultar Planos</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                    <div class="exibeplanos" v-else>    
                        <div class="planos-wrapper">
                            <p class="planos-title">Região:  {{this.nomeAgrupamento}}
                                <v-btn
                                    icon        
                                    dark
                                    @click.prevent="exibeLocalizacao = !exibeLocalizacao"
                                    color="#7e2985"
                                >
                                    <v-icon style="margin-right: 0%;">cached</v-icon>
                                </v-btn>
                            </p>
                            <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
                            <v-container grid-list-md>
                                <v-layout row wrap justify-center>
                                    <v-flex v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md12 lg4>
                                        <div class="list-planos">
                                            <div class="item">
                                                <!-- <h6 class="dePara">De</h6>
                                                <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                                                <h6 class="dePara">Por</h6> -->
                                                <p class="price"><span>R$</span> {{plano.value}}<br><span>(Por pet)</span></p>
                                                <p class="cobertura"><span>{{plano.area_atuacao}}</span><b>{{plano.qualificacao}}</b></p>
                                                <div v-if="plano.typePayment == 'CARTAO'" style="height: 52px;" class="boleto">
                                                    <span>
                                                        <v-img 
                                                            max-height="20px"        
                                                            :src="require('@/Content/images/cartoes.png')"
                                                            max-width="60%"
                                                            style="margin-left: 50px;"
                                                        />
                                                    </span>
                                                    <v-icon style="margin-top: 2px;">credit_card</v-icon>
                                                    {{plano.name}}
                                                </div>
                                                <div v-else style="height: 52px;" class="boleto">
                                                    <i class="fas fa-barcode"></i>
                                                    {{plano.name}}
                                                </div>
                                                <a @click="contratoPF(plano)" class="button">Contratar plano</a>
                                            </div>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>        
                        </div>
                    </div>
                </v-fade-transition>
            </div>
        </section>
        <v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
            <v-card>
                <v-container grid-list-md>
                    <v-layout row wrap justify-center>
                        <v-card-title>
                            <span class="total">Prezado(a) cliente,</span>              
                        </v-card-title>
                        <v-container fluid pa-1 justify-center class="resumo">
                            <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a segurança e a tranquilidade que você precisa.</p>
                            <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
                            <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
                            <br>
                            <p class="resumo" style="font-weight: bold">A <span style="color:#666">{{informacaoOperadora("nome")}}</span> agradece a sua atenção!</p>
                            <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!</p>
                            <br>
                            <p class="resumo" style="font-weight: bold;color:#666">Termo de Privacidade, <a href="https://PetHoooficial.intelite.com.br/docs/Politica_de_Privacidade_MAIS_PET.pdf" target="_blank">clique aqui.</a></p>
                            <v-checkbox v-model="contrataccept" color="#7e2985">
                                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da {{informacaoOperadora("nome")}}.</span>
                            </v-checkbox>
                        </v-container>
                    </v-layout>
                    <v-card-actions>
                        <v-container fill-height fluid pa-1 justify-center>
                            <br>
                            <v-btn @click="confirmaPlano()" color="#7e2985" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
                        </v-container>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
        <div class="whatsappIcon" v-if="whatsapp">
            <a target="_blank" :href="whatsapp">
                <img height="60" src="../assets/whatsapp.png" />
            </a>
        </div>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    import { baseApiUrl, operadora, } from '@/global'
    export default {
        components: {Snackbar},
        data() {
            return {
                dialog: false,
                abrangenciaAgrupamento: '',
                exibeLocalizacao: true,
                nomeAgrupamento: '',
                planos: [],
                vendedor: [],
                planoSelecionado: [],
                abrangencias: [],
                agrupamentosUF: [],
                abrangenciaUF: '',
                contrataccept: false,
                indicacao: '',
                whatsapp: '',
            };
        },

        /*  watch: {
            'estado': function () {
                this.cidades = brasil[this.estado].cidades
            }
        }, */
        
        mounted: function() {
            localStorage.clear()
            sessionStorage.clear()  
            this.pegaParametrosUrl()  
            this.$store.dispatch('ExibeToolbar')
            this.$store.dispatch('ExibeFooter')
            this.exibeLocalizacao = true;
            this.$store.dispatch('Logar')
            this.carregaAgrupametos()
        },

        methods: {
            informacaoOperadora(atributo) {
                return operadora[atributo]
            },

            scrollToClass(className) {
                // Get the first element with the given class name
                let el = this.$el.querySelector(className)
                // Get the bounding rectangle so we can get the element position position
                let rect = el.getBoundingClientRect()
                // Scroll to the element (using x and y axis)
                window.scrollTo(rect.left, rect.top)
            },

            scrollbotton() {
                window.scrollTo(0, 3000)
            },

            async controlaExibicaoPlanos() {
                if (this.abrangenciaAgrupamento == '') {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Selecione o local onde deseja utilizar o plano!","ATENÇÃO")
                } else {
                    for (var i=0; i<this.agrupamentosUF.length; i++) {
                        if (this.agrupamentosUF[i].abrangenciaId === this.abrangenciaAgrupamento) {
                            this.nomeAgrupamento = this.agrupamentosUF[i].agrupamento
                        }
                    }
                    /* if(this.nomeAgrupamento.includes("SP") || this.nomeAgrupamento.includes("MG") || this.nomeAgrupamento.includes("RO")) {
                        var vm2 = this;
                        vm2.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
                        return
                    } else { */
                        await axios.get(`${baseApiUrl}Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["${this.abrangenciaAgrupamento}"]}},{"qualificacao":{"inq":["Individual","Familiar"]}},{"publico":"Pessoa Física"}]}}`).then(res => {        
                            if (res.data != null) {
                                this.planos = res.data   
                            }
                        })
                    this.exibeLocalizacao = false;
                }
            },
            
            /* contratoPF(plano){
                this.dialog = true
                this.planoSelecionado = plano
            },*/

            contratoPF(plano) {
                localStorage.clear()
                sessionStorage.clear()
                this.planoSelecionado = plano
                this.$store.dispatch('planosPF', this.planoSelecionado)
                localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))   
                if (this.indicacao) {
                    sessionStorage.setItem('indicacao',this.indicacao)
                }
                if (this.vendedor != '')
                    sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor))        
                this.$router.push({ path: '/contratopf' })
            },

            calculaDesconto(plano) {
                var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
                //desconto = desconto.replace('.','.')
                return desconto.toFixed(2).replace('.',',')
            },

            async carregaAgrupametos() {
                this.abrangenciaOrgao = ''
                await axios.get(`${baseApiUrl}AgrupamentoUFs?filter[where][status]=Ativo`).then(res => {        
                    if (res.data != null) {
                        this.agrupamentosUF = res.data.sort(this.compare)
                    }
                })
            },

            compare(a, b) {
                // Use toUpperCase() to ignore character casing
                const agrupamentoA = a.agrupamento;
                const agrupamentoB = b.agrupamento;

                let comparison = 0;
                if (agrupamentoA > agrupamentoB) {
                    comparison = 1;
                } else if (agrupamentoA < agrupamentoB) {
                    comparison = -1;
                }
                return comparison;
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('&');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};
                    //Passar por todos os parametros
                    for (var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');
                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['vendedor']) {
                        await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {
                            if (res.data != null) {
                                //console.log(res.data[0])
                                this.vendedor = res.data[0]           
                                if (this.vendedor.whatsapp) {
                                    this.whatsapp = "https://wa.me/" + this.vendedor.whatsapp + "?text=Olá,%20pode%20me%20ajudar?"
                                }
                            }
                        })
                    }
                    if (paramArray['indicacao']) {
                        this.indicacao = paramArray['indicacao']
                    }
                }
            }
        }
    }
</script>

<style>
    .localizacao {
        border: 1px solid;
        border-color: #7e2985;
    }

    .whatsappIcon {
      position: fixed;
      bottom: 70px;
      right: 0px;
      clear: both;
    }

    .whatsappIcon img:hover {
      transition: 0.4s;
      -webkit-transform: scale(1.2);
      -moz-transform: scale(1.2);
      -o-transform: scale(1.2);
      -ms-transform: scale(1.2);
      transform: scale(1.2);
    }

    .whatsappIcon img {
      transition: 0.4s;
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -o-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
</style>
